// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid-module--grid--bO5dy"};